var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('publish-field',{attrs:{"config":_vm.fieldConfig,"value":_vm.value,"errors":_vm.fieldErrors},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }